import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { CommodityService } from 'pages/system-fields/commodities/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(CommodityService, DialogService, EventAggregator)
export class Commodity {
    constructor(commodityService, dialogService, ea) {
        this.ea = ea;
        this.commodityService = commodityService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('commodities:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (commodity) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.commodityService.delete(commodity.id);
                this.grid.refresh();
                toastr.success('Commodity was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.commodityService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.commodityService.editor, model: { id: data.id } });
    };
}